import React, { useEffect, useRef, useState } from "react";
import { Button } from "@/components/ui/button";
import { Mic, MicOff } from "lucide-react";
import { toast } from "sonner";

export default function VoiceInput({ onTranscript, lang = "it-IT" }) {
  const [listening, setListening] = useState(false);
  const recRef = useRef(null);

  useEffect(() => {
    return () => { try { recRef.current?.stop(); } catch {} };
  }, []);

  const supported = typeof window !== "undefined" && (window.SpeechRecognition || window.webkitSpeechRecognition);

  const start = () => {
    if (!supported) { toast.error("Dettatura non supportata su questo browser"); return; }
    const SR = window.SpeechRecognition || window.webkitSpeechRecognition;
    const rec = new SR();
    rec.lang = lang;
    rec.continuous = false;
    rec.interimResults = false;
    rec.onresult = (e) => {
      const t = Array.from(e.results).map(r => r[0].transcript).join(" ");
      if (t && onTranscript) onTranscript(t);
    };
    rec.onerror = (e) => { toast.error("Errore dettatura: " + e.error); setListening(false); };
    rec.onend = () => setListening(false);
    rec.start();
    recRef.current = rec;
    setListening(true);
    toast("Sto ascoltando...", { duration: 1500 });
  };

  const stop = () => { try { recRef.current?.stop(); } catch {}; setListening(false); };

  if (!supported) return null;
  return (
    <Button type="button" size="icon" variant={listening ? "default" : "outline"} className={listening ? "bg-red-500 hover:bg-red-600 text-white animate-pulse" : ""} onClick={() => listening ? stop() : start()} data-testid="voice-input-btn" title={listening ? "Stop dettatura" : "Avvia dettatura"}>
      {listening ? <MicOff className="w-4 h-4" /> : <Mic className="w-4 h-4" />}
    </Button>
  );
}
